import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import Swal from "sweetalert2";
import "./Home.css";

const services = [
  { value: "sem_ppc", label: "Search Engine Marketing (SEM/PPC)" },
  { value: "social_media", label: "Social Media" },
  { value: "website_dev", label: "Website Development" },
  { value: "website_managed", label: "Website Managed Services" },
  { value: "seo", label: "Search Engine Optimization (SEO)" },
  { value: "google_local", label: "Google Local Services Ads" },
  { value: "product_listing", label: "Product Listing Ads" },
  { value: "chatbot_dev", label: "Chatbot Development" },
];

const ContactForm = () => {
  const [selected, setSelected] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const toggleOption = (value) => {
    setSelected((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    formData.append("access_key", "2d704a51-fdc8-486a-b93e-82ae74ab09e8");

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        Swal.fire({
          title: "Thank You!",
          text: "Your message has been sent successfully",
          icon: "success",
          confirmButtonColor: "#3eaa9b",
          confirmButtonText: "OK",
        });

        event.target.reset();
        setSelected([]);
      } else {
        Swal.fire({
          title: "Oops!",
          text: "Something went wrong. Please try again later.",
          icon: "error",
          confirmButtonColor: "#d33",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Network Error",
        text: "Unable to send your message. Please check your internet connection.",
        icon: "error",
        confirmButtonColor: "#d33",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div className="backdiv">
      <h2 className="main_heading">
        WE CAN HELP <br /> CONTACT US TODAY !
      </h2>

      <div className="contact_grid">
        <div className="contact_imgdiv">
          <img
            src="/contact-us.webp"
            alt="About Us"
            className="zweedo_img"
            loading="lazy"
          />
        </div>

        <div className="contact_form_div">
          <form className="contact_form" onSubmit={onSubmit}>
            <div className="name-row">
              <input type="text" name="first_name" placeholder="First Name" required />
              <input type="text" name="last_name" placeholder="Last Name" required />
            </div>

            <div className="name-row">
              <input type="text" name="company_name" placeholder="Company Name" required />
              <input type="text" name="website_name" placeholder="Website Name" required />
            </div>

            <div className="name-row">
              <input type="number" name="phone_number" placeholder="Phone Number" required />
              <input type="email" name="user_email" placeholder="Your Email" required />
            </div>

            <select name="how you found out about us!" required>
              <option value="">We'd love to know how you found out about us!</option>
              <option value="google">Google Search</option>
              <option value="social_media">Social Media</option>
              <option value="friend">Friend / Referral</option>
              <option value="advertisement">Advertisement</option>
              <option value="other">Other</option>
            </select>

            {/* Custom Multi Select */}
            <div className="multiselect-container">
              <div
                className="multiselect-header"
                onClick={() => setIsOpen((prev) => !prev)}
              >
                <span>
                  {selected.length > 0
                    ? services
                        .filter((s) => selected.includes(s.value))
                        .map((s) => s.label)
                        .join(", ")
                    : "Select the service's you’re interested in"}
                </span>

                {isOpen ? (
                  <FaChevronUp className="arrow-icon" />
                ) : (
                  <FaChevronDown className="arrow-icon" />
                )}
              </div>

              {isOpen && (
                <div className="multiselect-options">
                  {services.map((service) => (
                    <label key={service.value} className="option">
                      <input
                        type="checkbox"
                        value={service.value}
                        checked={selected.includes(service.value)}
                        onChange={() => toggleOption(service.value)}
                      />
                      {service.label}
                    </label>
                  ))}
                </div>
              )}
              <input type="hidden" name="service's you’re interested in" value={selected.join(",")} />
            </div>

            <textarea
              name="message"
              placeholder="How can we be of service?"
              rows="4"
              required
            />

            <button className="contact_btn" type="submit">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
